import createClientMutation from 'my-phorest/gql/mutations/create-client.graphql';

export function validationModel(searchProperties) {
  const model = {
    firstName: searchProperties.firstName || '',
    lastName: searchProperties.lastName || '',
    phoneNumber: searchProperties.mobile || '',
    email: searchProperties.email || '',
  };
  return model;
}

export async function createClient(
  apollo,
  marketingConsentModal,
  clientSettings,
  linkedClient,
  searchProperties
) {
  let input = createNewClientData(
    clientSettings,
    linkedClient,
    searchProperties
  );
  const marketingPreferences =
    await marketingConsentModal.askIfAllowed.perform(input);
  if (marketingPreferences) {
    input = {
      ...input,
      ...marketingPreferences,
      marketingOptinAnswered: true,
    };
  }

  let response = await apollo.mutate(
    {
      mutation: createClientMutation,
      variables: { input },
      update: (cache) => {
        cache.evict({ id: 'ROOT_QUERY', fieldName: 'clients' });
        cache.gc();
      },
    },
    'createClient'
  );
  return response.client;
}

function createNewClientData(clientSettings, linkedClient, searchProperties) {
  const { firstName, lastName, phoneNumber, email } =
    validationModel(searchProperties);

  return {
    firstName,
    lastName,
    mobile: linkedClient ? '' : phoneNumber,
    email,
    linkedClientId: linkedClient ? linkedClient.id : null,
    marketingEmailOptout: clientSettings.defaultEmailMarketingOptOut,
    marketingSmsOptout: clientSettings.defaultSmsMarketingOptOut,
    marketingOptinAnswered: false,
  };
}
